import type { TaskSubmitFormValues } from '~/components/GenerationTask/BaseTaskSubmitForm'
import type { GenerationModelVersion } from '~/services/apollo/generated/graphql'
import { canModelUseStyleKey } from '~/utils/model'

export function checkLoraAndStyleKeyWarn(args: {
  taskModelVersion?: GenerationModelVersion
  values: TaskSubmitFormValues
}): boolean {
  if (!canModelUseStyleKey(args.taskModelVersion?.extra)) return false
  const hasSelectedStyleKey = !!args.values.modelStyle
  const hasSelectedLora = Object.keys(args.values.lora ?? {}).length > 0
  if (hasSelectedStyleKey && hasSelectedLora) return true

  return false
}
